import { createTheme } from "@mantine/core"

export const theme = createTheme({
  fontFamily: "Poppins",
  // primaryColor: "red",
  // ... other theme override properties
  colors: {
    black: ["#DBDCE0", "#B8B9C0", "#9495A1", "#707281", "#4D4F62", "#2E3046", "#11142D", "#0E1126", "#0C0E20", "#090B19"],
    white: ["#FFFFFF", "#FFFFFF", "#FFFFFF", "#FFFFFF", "#FFFFFF", "#FFFFFF", "#FFFFFF", "#D9D9D9", "#B3B3B3", "#8C8C8C"],
    gray: ["#E3E3E7", "#C6C7CF", "#AAABB7", "#8E8F9E", "#717486", "#595B71", "#42455E", "#383B50", "#2E3042", "#242634"],
    silver: ["#ECECEF", "#D9D9DE", "#C6C6CE", "#B3B3BD", "#A0A1AD", "#8F909E", "#808191", "#6D6E7B", "#5A5A66", "#464750"],
    ash: ["#F6F7F8", "#EDEFF2", "#E4E7EB", "#DCDFE5", "#D3D7DE", "#CBD0D8", "#C4CAD3", "#A7ACB3", "#898D94", "#6C6F74"],
    sand: ["#FDFDFD", "#FBFBFB", "#F9F9F9", "#F7F7F7", "#F5F5F5", "#F4F4F4", "#F2F2F2", "#CECECE", "#A9A9A9", "#858585"],
    blue: ["#DBDEE3", "#B7BDC8", "#939CAC", "#6E7B90", "#4A5A74", "#2B3D5C", "#0E2346", "#0C1E3C", "#0A1931", "#081327"],
    blueLight: ["#FEFEFE", "#FCFDFE", "#FBFCFD", "#FAFBFD", "#F8FAFC", "#F7F9FB", "#F6F8FB", "#D1D3D5", "#ACAEB0", "#87888A"],
    link: ["#E1ECFE", "#C2D9FE", "#A4C5FD", "#85B2FD", "#679FFC", "#4C8EFB", "#347FFB", "#2C6CD5", "#2459B0", "#1D468A"],
    red: ["#FCDDE1", "#FABAC4", "#F798A6", "#F47689", "#F2536B", "#EF3552", "#ED1A3A", "#C91631", "#A61229", "#820E20"],
    yellow: ["#FEF2E1", "#FDE6C2", "#FCD9A4", "#FBCC85", "#FBBF67", "#FAB44C", "#F9AA34", "#D4912C", "#AE7724", "#895E1D"],
    green: ["#E2EDE2", "#C5DBC5", "#A9C9A9", "#8CB68C", "#6FA46F", "#569556", "#3F863F", "#367236", "#2C5E2C", "#234A23"],
    violet: ["#EBE3F3", "#D7C6E8", "#C3AADC", "#AF8ED1", "#9B71C5", "#8A59BB", "#7A42B2", "#683897", "#552E7D", "#432462"],
    orange: ["#FEE9E0", "#FDD3C2", "#FCBDA3", "#FBA784", "#FA9265", "#F97F4B", "#F86D32", "#D35D2B", "#AE4C23", "#883C1C"],
  },
})
